export default "__VITE_ASSET__BXIUcwYV__"